import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./ctaBackDashboard.scss";

// const DASHBOARD_URL = process.env.REACT_APP_MACALLAN_DASHBOARD;

export default function CtaBackDashboard(props) {
  const { t } = useTranslation("common");

  const [isLargeScreen, setIsLargeScreen] = useState(
    window.matchMedia("(min-width: 768px)").matches
  );
  const [isNarrowTablet, setIsNarrowTablet] = useState(
    window.matchMedia("(max-width: 767px)").matches
  );

  useEffect(() => {
    const largeScreenMediaQuery = window.matchMedia("(min-width: 768px)");
    const narrowTabletMediaQuery = window.matchMedia("(max-width: 767px)");
    const setLargeScreenMediaQuery = () => {
      setIsLargeScreen(largeScreenMediaQuery.matches);
    };
    const setNarrowTabletMediaQuery = () => {
      setIsNarrowTablet(narrowTabletMediaQuery.matches);
    };

    try {
      largeScreenMediaQuery.addEventListener(
        "change",
        setLargeScreenMediaQuery
      );
      narrowTabletMediaQuery.addEventListener(
        "change",
        setNarrowTabletMediaQuery
      );
    } catch {
      largeScreenMediaQuery.addListener(setLargeScreenMediaQuery);
      narrowTabletMediaQuery.addListener(setNarrowTabletMediaQuery);
    }

    return () => {
      try {
        largeScreenMediaQuery.removeEventListener(
          "change",
          setLargeScreenMediaQuery
        );
        narrowTabletMediaQuery.removeEventListener(
          "change",
          setNarrowTabletMediaQuery
        );
      } catch {
        largeScreenMediaQuery.removeListener(setLargeScreenMediaQuery);
        narrowTabletMediaQuery.removeListener(setNarrowTabletMediaQuery);
      }
    };
  }, []);

  // TODO try to optimize this - remove?
  /*
  const resizeObserver = new ResizeObserver((entries) => {
    for (let entry of entries) {
      console.log('ro');
      this.setState({
        // used logo size which is 375px on biggest font size as foolproof indicator of big font size
        isBigFontSize: entry.contentRect.width > 370,
      });
    }
  });

  resizeObserver.observe(document.querySelector(".macalan-logo"));
  */

  const standardCondition =
    (isLargeScreen && props.showOnLargeScreen) ||
    (!isLargeScreen && !props.showOnLargeScreen);
  const bigFontSizeOnNarrowTablet = isLargeScreen && isNarrowTablet;

  if (
    bigFontSizeOnNarrowTablet ? !props.showOnLargeScreen : standardCondition
  ) {
    return (
      <div
        id="cta-back-dashboard"
        className={`cta-back-wrap ${
          bigFontSizeOnNarrowTablet ? "cta-back-wrap--tablet-below-content" : ""
        }`}
      >
        <button
          onClick={props.onClick}
          // href={DASHBOARD_URL}
          className="cta cta--secondary cta--noborder"
          // role="button"
          aria-label={`${t("button.dashboard_line1")} ${t(
            "button.dashboard_line2"
          )}`}
        >
          <i className="cta__icon icon icon-account"> </i>
          <div className="cta__content">
            <span>
              {t("button.dashboard_line1")}
              <br /> {t("button.dashboard_line2")}
            </span>
          </div>
        </button>
      </div>
    );
  } else {
    return null;
  }
}
